var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "flow-part-1" } }, [
      _vm._m(0),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Nombre para el flujo (*)",
                maxlength: "120",
                name: "name",
                danger: _vm.errors.has("flow-part-1.name"),
                "danger-text": _vm.errors.first("flow-part-1.name")
              },
              model: {
                value: _vm.step.name,
                callback: function($$v) {
                  _vm.$set(_vm.step, "name", $$v)
                },
                expression: "step.name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Descripción para el flujo (*)",
                name: "description",
                danger: _vm.errors.has("flow-part-1.description"),
                "danger-text": _vm.errors.first("flow-part-1.description"),
                maxlength: "550"
              },
              model: {
                value: _vm.step.description,
                callback: function($$v) {
                  _vm.$set(_vm.step, "description", $$v)
                },
                expression: "step.description"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        !_vm.step.oldFlow
          ? _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-8 d-flex align-items-end" },
                  [
                    _c("label", [_vm._v("Estampar aprobaciones")]),
                    _c("InfoApprovalStamp")
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-2" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: {
                          "vs-name": "pdfStamp",
                          "vs-value": true,
                          "data-cy": "pdfStampYes"
                        },
                        model: {
                          value: _vm.step.pdfStamp,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "pdfStamp", $$v)
                          },
                          expression: "step.pdfStamp"
                        }
                      },
                      [_vm._v(" Si ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-2" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: {
                          "vs-name": "pdfStamp",
                          "vs-value": false,
                          "data-cy": "pdfStampNo"
                        },
                        model: {
                          value: _vm.step.pdfStamp,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "pdfStamp", $$v)
                          },
                          expression: "step.pdfStamp"
                        }
                      },
                      [_vm._v(" No ")]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-8 d-flex align-items-end" },
              [_c("label", [_vm._v("Flujo privado")]), _c("InfoPrivateFlow")],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "private",
                      "vs-value": true,
                      "data-cy": "privateYes"
                    },
                    model: {
                      value: _vm.step.private,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "private", $$v)
                      },
                      expression: "step.private"
                    }
                  },
                  [_vm._v(" Si ")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "private",
                      "vs-value": false,
                      "data-cy": "privateNo"
                    },
                    model: {
                      value: _vm.step.private,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "private", $$v)
                      },
                      expression: "step.private"
                    }
                  },
                  [_vm._v(" No ")]
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-8 d-flex align-items-end" },
              [
                _c("label", [_vm._v("¿Quieres basarte en un flujo actual?")]),
                _c("InfoOldApproval")
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "oldFlow",
                      "vs-value": true,
                      "data-cy": "oldFlowYes"
                    },
                    model: {
                      value: _vm.step.oldFlow,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "oldFlow", $$v)
                      },
                      expression: "step.oldFlow"
                    }
                  },
                  [_vm._v(" Si ")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "oldFlow",
                      "vs-value": false,
                      "data-cy": "oldFlowNo"
                    },
                    model: {
                      value: _vm.step.oldFlow,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "oldFlow", $$v)
                      },
                      expression: "step.oldFlow"
                    }
                  },
                  [_vm._v(" No ")]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "row mt-3" }, [
        _vm.step.oldFlow
          ? _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "row", attrs: { "data-cy": "plantilla-tipo" } },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-12 d-flex align-items-end" },
                    [
                      _c("label", [_vm._v("¿Que plantillas quieres ver?")]),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-icon rounded-circle mt-1",
                              attrs: {
                                size: "sm",
                                id: "popover-attended",
                                variant: "flat-primary"
                              }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "InfoIcon" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "popover-attended",
                                triggers: "focus",
                                placement: "top"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("span", [
                                          _vm._v("Tipo de plantilla!")
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2424952843
                              )
                            },
                            [
                              _c("span", [
                                _c("strong", [_vm._v("Atendidas:")]),
                                _vm._v(
                                  " Flujos con interacción humana en donde cada participante debe realizar sus acciones "
                                )
                              ]),
                              _c("br"),
                              _c("span", [
                                _c("strong", [_vm._v(" Desatendidas: ")]),
                                _vm._v(
                                  " Flujos sin interacción humana que se procesan automáticamente "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "row",
                  attrs: { "data-cy": "plantilla-tipo-opciones" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c(
                        "vs-radio",
                        {
                          attrs: {
                            "vs-name": "attendedOnly",
                            "vs-value": 0,
                            "data-cy": "attendedOnly-0"
                          },
                          model: {
                            value: _vm.attendedOnly,
                            callback: function($$v) {
                              _vm.attendedOnly = $$v
                            },
                            expression: "attendedOnly"
                          }
                        },
                        [_vm._v(" Atendidas ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c(
                        "vs-radio",
                        {
                          attrs: {
                            "vs-name": "attendedOnly",
                            disabled: _vm.disableDesattendedOnly,
                            "vs-value": 1,
                            "data-cy": "attendedOnly-1"
                          },
                          model: {
                            value: _vm.attendedOnly,
                            callback: function($$v) {
                              _vm.attendedOnly = $$v
                            },
                            expression: "attendedOnly"
                          }
                        },
                        [_vm._v(" Desatendidas ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm.step.oldFlow
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("label", { attrs: { for: "flow-select" } }, [
                  _vm._v(" Selecciona el flujo ")
                ]),
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.filteredApprovalsTemplates,
                      name: "flow-select",
                      id: "flow-select",
                      label: "nombre",
                      "data-cy": "select-template",
                      placeholder: "Selecciona el flujo",
                      reduce: function(option) {
                        return option.id
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function(ref) {
                            var id = ref.id
                            var nombre = ref.nombre
                            return [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-cy-value": id,
                                    "data-cy-label": nombre
                                  }
                                },
                                [_vm._v(" " + _vm._s(nombre) + " ")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      936322944
                    ),
                    model: {
                      value: _vm.step.flowId,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "flowId", $$v)
                      },
                      expression: "step.flowId"
                    }
                  },
                  [
                    _c("template", { slot: "no-options" }, [
                      _vm._v(" no hay flujos ")
                    ])
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e(),
        !_vm.step.oldFlow
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                !_vm.isMasive
                  ? _c("BooleanParameter", {
                      attrs: {
                        "is-approval-sign": true,
                        disabled: _vm.disableSignaturePosition,
                        "param-id": "aprobaciones.firmas.ubicacion"
                      },
                      on: { input: _vm.onSetSignaturePositionChange },
                      model: {
                        value: _vm.step.setSignaturePosition,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "setSignaturePosition", $$v)
                        },
                        expression: "step.setSignaturePosition"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.hasOfficeOldFlow
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("list-document-types", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "documentTypes",
                  staticClass: "w-100",
                  attrs: {
                    "type-numeration":
                      _vm.numerationFlowType === "I" ? "numInt" : "numOf",
                    autocomplete: "",
                    label: "Tipo Documento (*)",
                    name: "documentTypeOffice",
                    danger: _vm.errors.has("flow-part-1.documentTypeOffice"),
                    "danger-text": _vm.errors.first(
                      "flow-part-1.documentTypeOffice"
                    ),
                    "data-vv-as": "tipo documento"
                  },
                  model: {
                    value: _vm.step.documentTypeOffice,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "documentTypeOffice", $$v)
                    },
                    expression: "step.documentTypeOffice"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("list-documents", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.hasOfficeOldFlow },
                      expression: "{'required': hasOfficeOldFlow}"
                    }
                  ],
                  ref: "documents",
                  staticClass: "w-100",
                  attrs: {
                    "type-numeration":
                      _vm.numerationFlowType === "I" ? "numInt" : "numOf",
                    autocomplete: "",
                    label: "Documento (*)",
                    name: "documentOffice",
                    "parent-value": _vm.step.documentTypeOffice,
                    "data-vv-as": "documento",
                    danger: _vm.errors.has("flow-part-1.documentOffice"),
                    "danger-text": _vm.errors.first(
                      "flow-part-1.documentOffice"
                    )
                  },
                  on: { "input-option": _vm.onDocumentTypeChangeNumeration },
                  model: {
                    value: _vm.step.documentOffice,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "documentOffice", $$v)
                    },
                    expression: "step.documentOffice"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.hasOfficeOldFlow
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("list-all-document-types", {
                  ref: "documentTypes",
                  staticClass: "w-100",
                  attrs: {
                    "data-vv-as": "tipo documento",
                    usage: "aprobaciones",
                    autocomplete: "",
                    label: "Tipo Documento",
                    name: "documentType"
                  },
                  on: { "input-option": _vm.onDocumentTypeChange },
                  model: {
                    value: _vm.step.documentType,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "documentType", $$v)
                    },
                    expression: "step.documentType"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mt-3" }, [
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Empresa (*)" } },
                  [
                    _c("v-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required:
                              _vm.isAguasAndinas &&
                              _vm.step.documentType &&
                              _vm.step.documentType
                                .toLowerCase()
                                .includes("carta")
                          },
                          expression:
                            "{required: isAguasAndinas && step.documentType\n         && step.documentType.toLowerCase().includes('carta')}"
                        }
                      ],
                      staticClass: "w-100 b-radius",
                      class: {
                        "v-select-danger": _vm.errors.has("flow-part-1.author"),
                        "select-size-sm": _vm.errors.has("flow-part-1.author")
                      },
                      attrs: {
                        options: _vm.authorAguasAndinas,
                        clearable: false,
                        "data-cy": "author",
                        name: "author",
                        "data-vv-as": "autor"
                      },
                      model: {
                        value: _vm.step.author,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "author", $$v)
                        },
                        expression: "step.author"
                      }
                    }),
                    _vm.errors.has("flow-part-1.author")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to",
                            staticStyle: { height: "19px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("flow-part-1.author")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-6 col-xs-12 col-sm-12 mt-3" },
              [
                _c("list-institution-types", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required:
                          _vm.isAguasAndinas &&
                          _vm.step.documentType &&
                          _vm.step.documentType.toLowerCase().includes("carta")
                      },
                      expression:
                        "{required: isAguasAndinas && step.documentType\n         && step.documentType.toLowerCase().includes('carta')}"
                    }
                  ],
                  ref: "institutionType",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Tipo Institución (*)",
                    name: "institutionType",
                    danger: _vm.errors.has("flow-part-1.institutionType"),
                    "danger-text": _vm.errors.first(
                      "flow-part-1.institutionType"
                    )
                  },
                  model: {
                    value: _vm.step.institutionType,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "institutionType", $$v)
                    },
                    expression: "step.institutionType"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row mb-3 mt-3" }, [
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("label", { attrs: { for: "matter" } }, [
                  _vm._v("Materia (*)")
                ]),
                _c("vs-textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required:
                          _vm.isAguasAndinas &&
                          _vm.step.documentType &&
                          _vm.step.documentType.toLowerCase().includes("carta"),
                        min: 3
                      },
                      expression:
                        "{\n            required: isAguasAndinas && step.documentType\n            && step.documentType.toLowerCase().includes('carta'),\n            min: 3\n          }"
                    }
                  ],
                  staticClass: "mb-0",
                  attrs: {
                    type: "text",
                    id: "matter",
                    label:
                      "Materia (Mínimo 3 caracteres, máximo 5000 caracteres)",
                    "data-cy": "matter",
                    name: "matter",
                    width: "100%",
                    height: "100px",
                    maxlength: "5000"
                  },
                  model: {
                    value: _vm.step.matter,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "matter", $$v)
                    },
                    expression: "step.matter"
                  }
                }),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6 text-left" }, [
                    _vm.errors.first("flow-part-1.matter")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger\n           vs-input--text-validation-span v-enter-to",
                            staticStyle: { height: "32px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("flow-part-1.matter")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm.step.matter
                    ? _c("div", { staticClass: "col-md-6 text-right" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.step.matter.length) + "/5000")]
                        )
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("label", [_vm._v("Fecha Documento")]),
                _c(
                  "b-form-datepicker",
                  _vm._b(
                    {
                      attrs: {
                        "today-button": "",
                        "reset-button": "",
                        "close-button": "",
                        max: _vm.maxDate,
                        locale: _vm.locale,
                        "show-decade-nav": false,
                        "hide-header": false,
                        name: "issueDate",
                        "data-vv-as": "fecha documento",
                        "data-cy": "issue-date"
                      },
                      model: {
                        value: _vm.step.issueDate,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "issueDate", $$v)
                        },
                        expression: "step.issueDate"
                      }
                    },
                    "b-form-datepicker",
                    _vm.configBFormDate.labels[_vm.locale] || {},
                    false
                  )
                ),
                _vm.errors.has("flow-part-1.issueDate")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to",
                        staticStyle: { height: "19px" }
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("flow-part-1.issueDate")
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "off",
                    "data-cy": "mother-document-number",
                    label: "Nº Documento Madre",
                    "data-vv-as": "documento madre",
                    name: "documentNumberMother"
                  },
                  on: {
                    keyup: function($event) {
                      return _vm.searchForMother()
                    }
                  },
                  model: {
                    value: _vm.step.motherDocument,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "motherDocument", $$v)
                    },
                    expression: "step.motherDocument"
                  }
                }),
                (_vm.motherDocumentsList.length > 0 ||
                  _vm.loadingMotherDocuments) &&
                _vm.showListSelect
                  ? _c(
                      "ul",
                      { attrs: { id: "list" } },
                      [
                        _vm.loadingMotherDocuments
                          ? _c("li", [
                              _c("span", { staticClass: "muted-light" }, [
                                _vm._v("Buscando...")
                              ])
                            ])
                          : _vm._e(),
                        _vm._l(_vm.motherDocumentsList, function(item) {
                          return _c(
                            "li",
                            {
                              key: item.numero,
                              on: {
                                click: function($event) {
                                  return _vm.setDocumentMother(item)
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(item.numero))]),
                              _c("span", { staticClass: "muted-light" }, [
                                _vm._v(
                                  " creado el " +
                                    _vm._s(_vm.formatDate(item.fechaCreacion)) +
                                    " "
                                )
                              ]),
                              _c("span", { staticClass: "muted-light" }, [
                                _vm._v(
                                  " nº interno " + _vm._s(item.numeroInt) + " "
                                )
                              ]),
                              _c("p", [
                                _vm._v("Creado por "),
                                _c("b", [
                                  _vm._v(_vm._s(item.solicitanteNombre))
                                ]),
                                _vm._v(
                                  " (" + _vm._s(item.solicitanteEmail) + ")"
                                )
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.error.message
                  ? _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.error.message))
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Tema (*)" } },
                  [
                    _c("v-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required:
                              _vm.isAguasAndinas &&
                              _vm.step.documentType &&
                              _vm.step.documentType
                                .toLowerCase()
                                .includes("carta")
                          },
                          expression:
                            "{required: isAguasAndinas && step.documentType\n         && step.documentType.toLowerCase().includes('carta')}"
                        }
                      ],
                      staticClass: "w-100 b-radius",
                      class: {
                        "v-select-danger": _vm.errors.has("flow-part-1.theme"),
                        "select-size-sm": _vm.errors.has("flow-part-1.theme")
                      },
                      attrs: {
                        options: _vm.themesAguasAndinas,
                        clearable: false,
                        reduce: function(option) {
                          return option.id
                        },
                        "data-cy": "theme",
                        name: "theme",
                        "data-vv-as": "tema"
                      },
                      model: {
                        value: _vm.step.theme,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "theme", $$v)
                        },
                        expression: "step.theme"
                      }
                    }),
                    _vm.errors.has("flow-part-1.theme")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to",
                            staticStyle: { height: "19px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("flow-part-1.theme")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.isAguasAndinas &&
        _vm.step.documentType &&
        _vm.step.documentType.toLowerCase().includes("carta")
          ? _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Sub-tema (*)" } },
                  [
                    _c("v-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required:
                              _vm.isAguasAndinas &&
                              _vm.step.documentType &&
                              _vm.step.documentType
                                .toLowerCase()
                                .includes("carta")
                          },
                          expression:
                            "{required: isAguasAndinas && step.documentType\n         && step.documentType.toLowerCase().includes('carta')}"
                        }
                      ],
                      staticClass: "w-100 b-radius",
                      class: {
                        "v-select-danger": _vm.errors.has(
                          "flow-part-1.subtheme"
                        ),
                        "select-size-sm": _vm.errors.has("flow-part-1.subtheme")
                      },
                      attrs: {
                        options: _vm.subThemesAguasAndinas,
                        reduce: function(option) {
                          return option.id
                        },
                        clearable: false,
                        "data-cy": "sub-theme",
                        name: "subtheme",
                        "data-vv-as": "sub-tema"
                      },
                      model: {
                        value: _vm.step.subTheme,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "subTheme", $$v)
                        },
                        expression: "step.subTheme"
                      }
                    }),
                    _vm.errors.has("flow-part-1.subtheme")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to",
                            staticStyle: { height: "19px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("flow-part-1.subtheme")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.isAguasAndinas &&
      _vm.step.documentType &&
      _vm.step.documentType.toLowerCase().includes("carta")
        ? _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
          ])
        : _vm._e(),
      _vm.isAguasAndinas &&
      _vm.step.documentType &&
      _vm.step.documentType.toLowerCase().includes("carta")
        ? _c("div", { staticClass: "row mb-3" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "col-md-12 mb-3" },
              [
                _c("add-related-document", {
                  on: { "add-related-document": _vm.addRelatedDocument }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("table-related-documents", {
                  attrs: {
                    "related-documents": _vm.step.relatedDocuments,
                    multiple: ""
                  },
                  model: {
                    value: _vm.step.relatedDocumentsSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "relatedDocumentsSelected", $$v)
                    },
                    expression: "step.relatedDocumentsSelected"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.isAguasAndinas &&
      _vm.step.documentType &&
      _vm.step.documentType.toLowerCase().includes("carta")
        ? _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row mb-3 mt-4" },
        [
          _c(
            "div",
            { staticClass: "col-md-3 d-flex align-items-end" },
            [
              _c("UploadFile", {
                attrs: {
                  permission: "*",
                  text: "Cargar Archivos Adjuntos",
                  accept: "application/pdf",
                  "upload-to": "ed",
                  "button-class": "btn-block",
                  "container-class": "w-100"
                },
                on: {
                  input: function($event) {
                    return _vm.addAdditionalFile()
                  }
                },
                model: {
                  value: _vm.additionalFile,
                  callback: function($$v) {
                    _vm.additionalFile = $$v
                  },
                  expression: "additionalFile"
                }
              })
            ],
            1
          ),
          _vm._l(_vm.step.attachments, function(file) {
            return _c("div", { key: file.id, staticClass: "col-3" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _c("vs-icon", {
                    attrs: {
                      icon: "description",
                      size: "45px",
                      color: "primary"
                    }
                  }),
                  _c("b", { staticClass: "text-truncate w-100 text-center" }, [
                    _vm._v(_vm._s(file.name))
                  ]),
                  _c("vs-button", {
                    attrs: { color: "danger", type: "flat", icon: "clear" },
                    on: {
                      click: function($event) {
                        return _vm.removeAdditionalFile(file.id)
                      }
                    }
                  })
                ],
                1
              )
            ])
          })
        ],
        2
      )
    ]),
    _c(
      "form",
      { attrs: { "data-vv-scope": "flow-part-2" } },
      [
        _vm._m(2),
        _vm.step.oldFlow && _vm.oldFlow.pasos
          ? _c("StepsOldFlow", { attrs: { steps: _vm.oldFlow.pasos } })
          : _vm._e(),
        !_vm.step.oldFlow
          ? _c("div", { staticClass: "row mb-5" }, [
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c(
                    "vs-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "",
                        label: "Tipo de paso (*)",
                        name: "stepType",
                        danger: _vm.errors.has("flow-part-2.stepType"),
                        "danger-text": _vm.errors.first("flow-part-2.stepType")
                      },
                      model: {
                        value: _vm.stepType,
                        callback: function($$v) {
                          _vm.stepType = $$v
                        },
                        expression: "stepType"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: _vm.stepTypes.USER, text: "Usuario" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: _vm.stepTypes.GROUP, text: "Grupo" }
                      }),
                      _vm.isGore &&
                      _vm.officeStepDoc.includes(_vm.wizardData.documentType)
                        ? _c("vs-select-item", {
                            attrs: {
                              value: _vm.stepTypes.OFFICE,
                              text: "Oficina"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.stepType === this.stepTypes.OFFICE
                ? _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("list-offices", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: _vm.stepType === this.stepTypes.OFFICE
                            },
                            expression:
                              "{ required: stepType === this.stepTypes.OFFICE }"
                          }
                        ],
                        ref: "groupStep",
                        staticClass: "w-100 mb-1",
                        attrs: {
                          autocomplete: "",
                          label: "Oficina del responsable",
                          name: "groupStep",
                          "data-vv-as": "oficina",
                          typeList: 99,
                          withFilters: "",
                          officeType: _vm.typeNumeration,
                          filterMyOffices: _vm.filterUserOffices,
                          danger: _vm.errors.has("flow-part-2.groupStep"),
                          "danger-text": _vm.errors.first(
                            "flow-part-2.groupStep"
                          )
                        },
                        model: {
                          value: _vm.groupStep,
                          callback: function($$v) {
                            _vm.groupStep = $$v
                          },
                          expression: "groupStep"
                        }
                      }),
                      _c("small", { staticClass: "text-danger" }, [
                        _vm._v(
                          " Si le falta una oficina, favor notificar al equipo de Soporte para que verifiquen que esté correctamente configurada "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stepType === _vm.stepTypes.GROUP
                ? _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("list-groups", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: _vm.stepType === _vm.stepTypes.GROUP
                            },
                            expression:
                              "{ required: stepType === stepTypes.GROUP }"
                          }
                        ],
                        ref: "groupStep",
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "",
                          label: "Grupo del responsable (*)",
                          name: "groupStep",
                          typeList: _vm.stepType,
                          officeType: _vm.wizardData.fileCategory,
                          danger: _vm.errors.has("flow-part-2.groupStep"),
                          "danger-text": _vm.errors.first(
                            "flow-part-2.groupStep"
                          )
                        },
                        model: {
                          value: _vm.groupStep,
                          callback: function($$v) {
                            _vm.groupStep = $$v
                          },
                          expression: "groupStep"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stepType === _vm.stepTypes.USER
                ? _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("list-user", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: _vm.stepType === _vm.stepTypes.USER
                            },
                            expression:
                              "{ required: stepType === stepTypes.USER }"
                          }
                        ],
                        ref: "userStep",
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "",
                          label: "Usuario (*)",
                          name: "userStep",
                          isApprovals: "",
                          danger: _vm.errors.has("flow-part-2.userStep"),
                          "danger-text": _vm.errors.first(
                            "flow-part-2.userStep"
                          )
                        },
                        model: {
                          value: _vm.userStep,
                          callback: function($$v) {
                            _vm.userStep = $$v
                          },
                          expression: "userStep"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stepType !== _vm.stepTypes.OFFICE
                ? _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Tipo de rol (*)" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              danger: _vm.errors.has("flow-part-2.rolType")
                            },
                            attrs: {
                              id: "rolType",
                              label: "label",
                              options: _vm.rolTypesOption,
                              reduce: function(rol) {
                                return rol.id
                              },
                              name: "rolType"
                            },
                            model: {
                              value: _vm.rolType,
                              callback: function($$v) {
                                _vm.rolType = $$v
                              },
                              expression: "rolType"
                            }
                          }),
                          _c("InfoRolType"),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("flow-part-2.rolType"),
                                  expression:
                                    "errors.has('flow-part-2.rolType')"
                                }
                              ],
                              staticClass:
                                "danger span-text-validation-danger v-enter-to"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first("flow-part-2.rolType")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stepType === _vm.stepTypes.OFFICE
                ? _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Tipo de rol" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              danger: _vm.errors.has("flow-part-2.rolType")
                            },
                            attrs: {
                              label: "label",
                              options: _vm.rolTypesOfficeOption,
                              reduce: function(rol) {
                                return rol.id
                              },
                              name: "rolType"
                            },
                            model: {
                              value: _vm.rolType,
                              callback: function($$v) {
                                _vm.rolType = $$v
                              },
                              expression: "rolType"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "text-right" },
                            [
                              _vm._v(" info "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-icon rounded-circle mt-1",
                                  attrs: {
                                    size: "sm",
                                    id: "popover-button-default",
                                    variant: "flat-primary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "InfoIcon" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "popover-button-default",
                                    triggers: "focus",
                                    placement: "top"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function() {
                                          return [
                                            _c("span", [
                                              _vm._v("Tipos de roles!")
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2187985360
                                  )
                                },
                                [
                                  _c("span", [
                                    _c("b", [_vm._v("+ Numerar/tramitar:")]),
                                    _vm._v(
                                      " Permite firmar documentos, esto cuenta como la aprobación, se coloca un estampado de numeración o trámite. "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("flow-part-2.rolType"),
                                  expression:
                                    "errors.has('flow-part-2.rolType')"
                                }
                              ],
                              staticClass:
                                "danger span-text-validation-danger v-enter-to"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first("flow-part-2.rolType")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e(),
        !_vm.step.oldFlow
          ? _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 d-flex align-items-end justify-content-end"
                },
                [
                  _c(
                    "vs-button",
                    {
                      attrs: {
                        color: "primary",
                        icon: "add",
                        disabled: _vm.blockButton,
                        "data-cy": "add-step"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addStep()
                        }
                      }
                    },
                    [_vm._v(" Agregar Paso ")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.step.steps.length
          ? _c(
              "div",
              { staticClass: "row mb-3" },
              _vm._l(_vm.step.steps, function(step, index) {
                return _c(
                  "div",
                  { key: "step-" + index, staticClass: "col-3" },
                  [
                    _c("div", { staticClass: "step-wrapper" }, [
                      _c("span", { staticClass: "step-number" }, [
                        _vm._v(_vm._s(step.stepNumber))
                      ]),
                      _c(
                        "span",
                        { staticClass: "step-delete" },
                        [
                          _c("vs-icon", {
                            attrs: {
                              icon: "highlight_off",
                              size: "small",
                              bg: "white",
                              round: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeStep(step)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "text-center step-name" }, [
                        _vm._v(" " + _vm._s(step.responsibleName) + " "),
                        step.stepType === _vm.stepTypes.GROUP ||
                        step.stepType === _vm.stepTypes.OFFICE
                          ? _c("span", [
                              _vm._v(" " + _vm._s(step.groupUsers.length) + " ")
                            ])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "step-type" }, [
                        step.stepType === _vm.stepTypes.USER
                          ? _c("span", [_vm._v(" usuario ")])
                          : _vm._e(),
                        step.stepType === _vm.stepTypes.GROUP
                          ? _c("span", [_vm._v(" grupo ")])
                          : _vm._e(),
                        step.stepType === _vm.stepTypes.OFFICE
                          ? _c("span", [_vm._v(" oficina ")])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "step-rol" }, [
                        step.rolType === _vm.rolTypes.APPROVER
                          ? _c("span", [_vm._v(" aprobador ")])
                          : _vm._e(),
                        step.rolType === _vm.rolTypes.SIGNER &&
                        step.stepType !== _vm.stepTypes.OFFICE
                          ? _c("span", { staticClass: "bg-success badges" }, [
                              _vm._v(" Firmante ")
                            ])
                          : _vm._e(),
                        step.rolType === _vm.rolTypes.SIGNER &&
                        step.stepType === _vm.stepTypes.OFFICE
                          ? _c("span", { staticClass: "bg-success badges" }, [
                              _vm._v(" Numerar/tramitar ")
                            ])
                          : _vm._e(),
                        step.rolType === _vm.rolTypes.REVIEWER
                          ? _c("span", [_vm._v(" revisor ")])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm.error.message !== ""
          ? _c(
              "div",
              {
                staticClass:
                  "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                staticStyle: { height: "32px" }
              },
              [
                _c("span", { staticClass: "span-text-validation" }, [
                  _vm._v(" " + _vm._s(_vm.error.message) + " ")
                ])
              ]
            )
          : _vm._e(),
        (_vm.isGore || _vm.isInh) && _vm.showSubjectsButton
          ? _c(
              "div",
              [
                _c(
                  "h6",
                  {
                    staticClass: "my-2 text-primary",
                    staticStyle: { "font-size": "12px" }
                  },
                  [_vm._v(" destinos ")]
                ),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal",
                        value: "modal-subjects",
                        expression: "'modal-subjects'"
                      },
                      {
                        name: "ripple",
                        rawName: "v-ripple.400",
                        value: "rgba(113, 102, 240, 0.15)",
                        expression: "'rgba(113, 102, 240, 0.15)'",
                        modifiers: { "400": true }
                      }
                    ],
                    staticClass: "btn-icon rounded-circle shadow-lg",
                    attrs: {
                      variant: "outline-info",
                      "data-cy": "btn-destinations"
                    }
                  },
                  [_c("feather-icon", { attrs: { icon: "UsersIcon" } })],
                  1
                ),
                _c("Subjects")
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Datos para el flujo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", [_vm._v("Documentos Relacionados")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3 mt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Detalle del flujo")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }